"use client"

import { CircleUser } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleUserIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleUserIcon = component(Icon)({ as: CircleUser })
